import React from "react";
import { CalendarDays, Check, ListFilter } from "lucide-react";
import { chosenLines } from "../lib/checkoutGroup";
import TrainerLine from "./TrainerLine";

/**
 * The cohort chosen on the homepage, confirmed rather than asked again.
 *
 * The whole list waits behind "Vezi și celelalte grupe": somebody who tapped
 * the wrong card has to be able to change it without going back to the
 * homepage — but nobody should have to answer a question they already
 * answered, on a form that then runs for three more sections (29.09.2026).
 */
export default function ChosenGroupCard({ group, onShowAll }) {
  const { name, start, meta } = chosenLines(group);
  return (
    <div
      className="rounded-2xl border border-[#965EA7]/30 bg-[#965EA7]/[0.04] p-5"
      data-testid="checkout-chosen-group"
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-[#965EA7] text-white">
          <Check size={14} strokeWidth={3} aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <div className="font-display text-base font-bold leading-snug text-[#373A45]">{name}</div>
          {start && (
            <div className="mt-1 flex items-center gap-2 text-sm text-[#373A45]">
              <CalendarDays size={15} className="shrink-0 text-[#965EA7]" />
              <span>{start}</span>
            </div>
          )}
          {meta && <div className="mt-1 text-sm text-[#6B7280]">{meta}</div>}
          <TrainerLine trainer={group?.trainer} pending={group?.trainer_pending} label="Formatorul tău:" className="mt-3" testid="checkout-chosen-trainer" />
        </div>
      </div>
      {/* A cohort reached through its own link has no others to show. */}
      {onShowAll && <button
        type="button"
        onClick={onShowAll}
        aria-expanded={false}
        className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-[#E5E7EB] bg-white px-3.5 py-1.5
                   text-xs font-semibold text-[#7A4986] transition-colors hover:border-[#965EA7]/50 hover:bg-[#F0E7F4]/60
                   focus:outline-none focus-visible:ring-2 focus-visible:ring-[#965EA7]/60"
        data-testid="checkout-show-all-groups"
      >
        <ListFilter size={13} aria-hidden="true" /> Vezi și celelalte grupe
      </button>}
    </div>
  );
}
